import {Component, Input, OnInit, SimpleChanges, Output, EventEmitter} from '@angular/core';

import {Nodo} from '../nodo/nodo';
import {Sensor} from '../sensor/sensor';
import {Sucursal} from '../sucursal/sucursal';
import {TipoVariable} from '../tipoVariable/tipoVariable';

import {SensorService} from './sensor.service';
import {TipoVariableService} from '../tipoVariable/tipoVariable.service';
import {PermisoService} from '../permiso/permiso.service';
import {LoginService} from '../login/login.service';

declare var $: any;
import * as _ from "lodash";

@Component({
    selector: 'sensor',
    template: require('../../app/sensor/sensor.component.html'),
    styles: [require('../../app/sensor/sensor.component.css')]
})
export class SensorComponent implements OnInit {

    @Input() nodo: Nodo;
    @Input() sensor: Sensor;
    @Input() sucursal: Sucursal;

    active: any;
    deshabilitar: boolean;
    tiposVariables: TipoVariable[];
    @Output() permisos = new EventEmitter();
    usuario: any;

    constructor(private sensorService: SensorService,
                private tipoVariableService: TipoVariableService,
                private permisoService: PermisoService,
                private loginService: LoginService,) {
    }

    ngOnInit() {
        this.nodo = new Nodo();
        this.sensor = new Sensor();
        this.active = true;

        //Pedir permisos
        this.permisoService.getPermiso("sensor").subscribe(permisos => {
            var respuesta = new Map();
            for (let permiso of permisos.tipoPermiso) {
                respuesta.set(permiso.descripcion, true);
            }
            this.permisos.emit({permisos: respuesta});
        })

        this.usuario = this.loginService.getDecodeToken();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.tipoVariableService.getTipoVariables()
            .subscribe((tipos) => this.tiposVariables = tipos);
    }


    closeModal() {
        //Reseteo formEmpresa para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Inicializo variables
        if (this.sensor._id != undefined && this.sensor._id != "" && this.sensor._id != null)
            this.sensorService.getSensor(this.sensor._id).subscribe((sensor) => {
                for (let sensorL of this.nodo.sensores_id) {
                    if (sensorL._id == sensor._id) {
                        sensorL.etiqueta = sensor.etiqueta;
                        sensorL.posicionString = sensor.posicionString;
                        sensorL.numeroMediciones = sensor.numeroMediciones;
                        sensorL.tipo_id = sensor.tipo_id;
                        break;
                    }
                }
            });
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        //Ocultar modal
        $("#modalSensor").modal("hide");
        $("#confirmacionSensor").modal("hide");
    }


    eliminar() {
        //Busco sensor
        this.sensorService
            .getSensor(this.sensor._id)
            .subscribe(sensor => {
                this.sensorService.delete(sensor).subscribe(
                    (sensor) => {
                        for (let sensorL of this.nodo.sensores_id) {
                            if (sensorL._id == sensor._id) {
                                sensorL.estado = sensor.estado;
                                if (!sensor.estado && sensorL.alarmas)
                                    for (let alarma of sensorL.alarmas) {
                                        alarma.estado = sensor.estado;
                                        for (let aviso of alarma.avisosLista) {
                                            aviso.estado = sensor.estado;
                                        }
                                    }
                                break;
                            }

                        }
                    }
                );
                $("#confirmacionSensor").modal("hide");
            });
    }

    save() {
        //Determino operacion
        var operacion = "";
        if (this.sensor._id == "" || this.sensor._id == undefined)
            operacion = "agregar";
        else
            operacion = "modificar";
        //Elimino redundancia
        this.sensor.nodo_id = this.nodo;
        var sensorSimplificado = _.cloneDeep(this.sensor);
        delete sensorSimplificado.alarmas;
        sensorSimplificado.nodo_id = this.nodo._id;
        sensorSimplificado.sucursal_id = this.sucursal._id;

        //Guardo
        this.sensorService
            .save(sensorSimplificado)
            .subscribe((sensor) => {
                //Inicializo variables
                this.sensor = sensor;
                //Actualizo listas
                if (operacion == "agregar") {
                    if (this.nodo.sensores_id == undefined)
                        this.nodo.sensores_id = [];
                    this.nodo.sensores_id.push(sensor);
                }
                else
                    for (let sensorL of this.nodo.sensores_id) {
                        if (sensorL._id == sensor._id) {
                            sensorL.etiqueta = sensor.etiqueta;
                            sensorL.posicionString = sensor.posicionString;
                            sensorL.numeroMediciones = sensor.numeroMediciones;
                            sensorL.tipo_id = sensor.tipo_id;
                            break;
                        }
                    }
                //this.sensor = sensor;
                //Ocultar modal
                $("#modalSensor").modal("hide");
                //Reseteo formEmpresa para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
            })
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/sensor/sensor.component.ts